/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class PremiumAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns any Success
   * @throws ApiError
   */
  public loadVehicleXml({
    vendorCnpj,
  }: {
    vendorCnpj: string;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/premium/loadvehiclexml/{vendorCnpj}",
      path: {
        vendorCnpj: vendorCnpj,
      },
    });
  }
}
